export default "__VITE_ASSET__DUQ5$mDt__"